import project4IMG1 from './img/project4/screenshot1.png';
import project4IMG2 from './img/project4/screenshot2.png';
import project4IMG3 from './img/project4/screenshot3.png';
import project3IMG1 from './img/project3/screenshot1.png';
import project3IMG2 from './img/project3/screenshot2.png';
import project3IMG3 from './img/project3/screenshot3.png';
import project2IMG1 from './img/project2/screenshot1.png';
import project2IMG2 from './img/project2/screenshot2.png';
import project2IMG3 from './img/project2/screenshot3.png';
import project5IMG1 from './img/project5/screenshot1.png';
import project5IMG2 from './img/project5/screenshot2.png';
import project5IMG3 from './img/project5/screenshot3.png';
import project1IMG1 from './img/project1/screenshot1.png';
import project1IMG2 from './img/project1/screenshot2.png';
import project1IMG3 from './img/project1/screenshot3.png';
import project6IMG1 from './img/project6/screenshot1.png';
import project6IMG2 from './img/project6/screenshot2.png';
import project6IMG3 from './img/project6/screenshot3.png';

const stockData = [
  {
    id: 1,
    title: 'Lodging app',
    tags: [
      'HTML',
      'CSS',
      'JavaScript',
      'Ruby on Rails',
      'React',
      'Redux',
    ],
    description: 'This app allows the user to reserve a room in a hotel in an easy way. The API was created with Ruby on Rails and the front-end with React.',
    live: 'https://goofy-panini-7f9108.netlify.app',
    source: 'https://github.com/mike2611/lodging-app-frontend',
    images: [
      project4IMG1,
      project4IMG2,
      project4IMG3,
    ],
  },
  {
    id: 2,
    title: 'Budget app',
    tags: [
      'HTML',
      'CSS',
      'Ruby on Rails',
    ],
    description: 'This is a mobile web application where users can manage their budget: They have a list of products associated with a category, so that they can see how much money they spent and on what.',
    live: 'https://secure-plateau-45841.herokuapp.com/',
    source: 'https://github.com/LOctavio/budget-app',
    images: [
      project3IMG1,
      project3IMG2,
      project3IMG3,
    ],
  },
  {
    id: 3,
    title: 'Metrics webapp',
    tags: [
      'HTML',
      'CSS',
      'React',
      'Redux',
    ],
    description: 'This app consumes the Narrativa API and shows a list of several countries and the confirmed covid cases of each one until 2021-08-01.',
    live: 'https://metrics-webapp-loctavio.netlify.app/',
    source: 'https://github.com/LOctavio/metrics-webapp',
    images: [
      project2IMG1,
      project2IMG2,
      project2IMG3,
    ],
  },
  {
    id: 4,
    title: 'Space travelers hub',
    tags: [
      'HTML',
      'CSS',
      'React',
      'Redux',
    ],
    description: 'This app using the real live data from the SpaceX API. This is an application for a fake company that provides commercial and scientific space travel services. The application will allow users to book rockets and join selected space missions.',
    live: 'https://space-travelers-hub-octavio-francis.netlify.app/',
    source: 'https://github.com/LOctavio/space-travelers-hub',
    images: [
      project5IMG1,
      project5IMG2,
      project5IMG3,
    ],
  },
  {
    id: 5,
    title: 'SEMF',
    tags: [
      'HTML',
      'CSS',
      'Sass',
    ],
    description: 'This is a web app that contains information about a fake Electronic music festival',
    live: 'https://rawcdn.githack.com/LOctavio/music-festival/191eb50f09433e2f89e77071b10802b1bccbb988/index.html',
    source: 'https://github.com/LOctavio/music-festival',
    images: [
      project1IMG1,
      project1IMG2,
      project1IMG3,
    ],
  },
  {
    id: 6,
    title: 'Picture of the day',
    tags: [
      'JavaScript',
      'HTML',
      'CSS',
    ],
    description: 'This is a web app that contains information about a fake Electronic music festival',
    live: 'https://rawcdn.githack.com/LOctavio/music-festival/191eb50f09433e2f89e77071b10802b1bccbb988/index.html',
    source: 'https://github.com/LOctavio/music-festival',
    images: [
      project6IMG1,
      project6IMG2,
      project6IMG3,
    ],
  },
];

export default stockData;
